export default __webpack_public_path__ + "static/media/263704.11afb8b6.png";